export const ROLES = {
  ADMIN: 'admin',
  GERENTE: 'manager',
  OPERADOR_BANCO: 'bank_operator',
  TAUALEGRE: 'recreator',
}

export const ROLE_REDIRECT = {
  [ROLES.ADMIN]: '/dashboard',
  [ROLES.GERENTE]: '/dashboard',
  [ROLES.OPERADOR_BANCO]: '/dashboard',
  [ROLES.TAUALEGRE]: '/dashboard',
}
